// extracted by mini-css-extract-plugin
export var OfferContainer = "PageOfferList-module--OfferContainer--856d8";
export var alt = "PageOfferList-module--alt--c111d";
export var badge = "PageOfferList-module--badge--16528";
export var button = "PageOfferList-module--button--c58df";
export var content = "PageOfferList-module--content--1891e";
export var description = "PageOfferList-module--description--057cf";
export var desktopOnly = "PageOfferList-module--desktopOnly--2d3d5";
export var links = "PageOfferList-module--links--617b6";
export var main = "PageOfferList-module--main--a6902";
export var mobileOnly = "PageOfferList-module--mobileOnly--06ba1";
export var offerContent = "PageOfferList-module--offerContent--5ec97";
export var teaserLink = "PageOfferList-module--teaserLink--8eae0";
export var textLeft = "PageOfferList-module--textLeft--13ffa";
export var title = "PageOfferList-module--title--40c1d";
export var visuallyHidden = "PageOfferList-module--visuallyHidden--0b5e2";